import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getCartData } from '../../redux/actions/cartActions'
import { getProfile } from '../../redux/actions/profileActions'
import { getUserOrders } from '../../redux/actions/orderActions'
import PakkettenShop from './PakkettenShop'
import PakketFilters from './PakketFilters'
import MobileSearchBar from '../layout/MobileSearchBar'

export class Pakketten extends Component {
  componentDidUpdate=(prevProps)=>{
    const { uid } = this.props.user.user
    if(prevProps.user !== this.props.user){
      
      this.props.getCartData(uid)   
      this.props.getProfile(uid) 
      this.props.getUserOrders()      
    }
  }
  
  componentDidMount=(prevProps)=>{
    
    const { uid } = this.props.user.user
    if(uid !== undefined){
      
      this.props.getUserOrders()      
      this.props.getCartData(uid)   
      this.props.getProfile(uid)       
    }
  }

  render() {
    const { pakketten } = this.props.products
    const pakkettenSort = pakketten.sort((a,b)=>
    a.volgNum - b.volgNum 
    )
    return (
      <div className="pakketten-shop-page">
        <div className="pakketten-shop">
        <MobileSearchBar />
        <PakketFilters />
        <PakkettenShop pakketten={pakkettenSort} />
        </div>
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  products: state.products,
  user: state.user,
  misc: state.misc
})

export default connect(mapStateToProps, {getCartData, getProfile, getUserOrders })(withRouter(Pakketten))
